import type { MouseEvent } from 'react';
import type { WithIntlProps } from 'react-intl';

import type {
  ContentSwitcherProps,
  ContentSwitcherDataProps,
} from '@xing-com/content-switcher';
import { ContentSwitcher } from '@xing-com/content-switcher';
import { useNavigate } from '@xing-com/crate-core-router';

import { addTrackingParamsToURL } from '../../utils/tracking';

export interface BaseContentSwitcherDataProps extends ContentSwitcherDataProps {
  to?: string;
  href?: string;
  trackingAttributes?: {
    [key: string]: string;
  };
}

export interface BaseContentSwitcherProps extends WithIntlProps<ContentSwitcherProps> {
  data: Array<BaseContentSwitcherDataProps>;
}

export const BaseContentSwitcher: React.FC<BaseContentSwitcherProps> = ({
  data,
  ...props
}) => {
  const navigate = useNavigate();

  const dataWithTracking = data.map(
    ({ trackingAttributes, onClick, ...other }) => {
      const handleTracking = (e: MouseEvent) => {
        e.preventDefault();
        const trackingUrl = addTrackingParamsToURL({
          url: other.to || other.href,
          params: trackingAttributes,
        });

        navigate(trackingUrl);
      };

      return {
        ...other,
        onClick: trackingAttributes ? handleTracking : onClick,
      };
    }
  );

  return <ContentSwitcher {...{ ...props, data: dataWithTracking }} />;
};
